import { render } from "./show-category.vue?vue&type=template&id=00431ae4&scoped=true&ts=true"
import script from "./show-category.vue?vue&type=script&lang=ts"
export * from "./show-category.vue?vue&type=script&lang=ts"

import "./show-category.vue?vue&type=style&index=0&id=00431ae4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00431ae4"]])

export default __exports__